export class RegisterFirstDeviceRequest {
  publicKey: string;
  encryptedUserKey: string;
  // Same persistent per-install identifier already sent as `device_identifier` on every
  // login (AppIdService.getAppId()) — ties this trusted_devices row back to this specific
  // browser so a later "google" grant from it can be recognized as a returning device
  // instead of only ever seeing isFirstDevice: false with no way to fetch its key back.
  deviceIdentifier: string;
  deviceName?: string;

  constructor(
    publicKey: string,
    encryptedUserKey: string,
    deviceIdentifier: string,
    deviceName?: string,
  ) {
    this.publicKey = publicKey;
    this.encryptedUserKey = encryptedUserKey;
    this.deviceIdentifier = deviceIdentifier;
    this.deviceName = deviceName;
  }
}
